import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './modules/app.module';
import { environment } from './environments/environment';

import localeCh from '@angular/common/locales/de-CH';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeCh, 'de-CH');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
